
export const GET_CONTENT_REQUEST  = 'GET_CONTENT_REQUEST';
export const GET_CONTENT_SUCCESS  = 'GET_CONTENT_SUCCESS';
export const GET_CONTENT_FAIL  = 'GET_CONTENT_FAIL';

export const GET_COURSE_CONFIG_SUCCESS = 'GET_COURSE_CONFIG_SUCCESS';
export const GET_COURSE_CONFIG_FAIL = 'GET_COURSE_CONFIG_FAIL';
export const GET_COURSE_CONFIG_REQUEST = 'GET_COURSE_CONFIG_REQUEST';